module.exports = __webpack_public_path__ + "assets/certificate_pdf/Big Data DatabaseNoSQL_Silicon Stone Education_2019-10-02.bb27ce0d.pdf";